import { WipType } from "../enums.generated";
import { BuildRowLinkTemplateArgs } from "../models/data-grid";
import { urlDataFormat } from "./string";

/**
 * Handler for building loan status row links.
 * @param args Args object containining necessary grid row information.
 * @returns The loan status URL.
 */
export function onLoanStatusBuildRowLinkTemplate (args: BuildRowLinkTemplateArgs) {

	let template: string;
	if (args.dataItem.mtaId) {
		template = args.urlService.url("MTA/Details/(mtaId)");
	}
	else if (args.dataItem.wipType === WipType.MTA) {
		template = args.options.rowLinkTemplate.replace("NewBusiness", "MTA");
	}
	else if (args.dataItem.agreementNumber) {
		template = args.dataItem.setLiveDate ? args.urlService.url("Agreement/(agreementNumber)") :
			args.options.rowLinkTemplate.replace("wip=(wipId)", "agt=(agreementNumber)");
	}
	else {
		template = args.options.rowLinkTemplate;
	}
	return urlDataFormat(template, args.dataItem);
}